<template>
	<div class="ipeq">
		<el-dialog class="gstdia" :title="$t('terminal.import_btn')" :visible.sync="showDia" @close="closeDia">
			<el-form :model="tform" v-loading="loading">
				<el-form-item label="" :label-width="fwidth">
					<div class="ipeqnum">1</div> 
					<div class="ipeqspl"></div>
					<div>
						<label slot="trigger" class="ipeqtt">{{ $t("app_download_template") }}</label>
						<el-button slot="trigger" style="margin-left: 10px" size="mini" type="primary"
							@click="downTempFile">
							<i class="el-icon-document"></i>
							{{ $t("app_download") }}
						</el-button>
					</div>
					<div class="el-upload__tip" style="font-size: 14px">
						{{ $t("app_download_device_message") }}
					</div>
				</el-form-item>
				<el-form-item label="" :label-width="fwidth">
					<div class="ipeqnum">2</div>
					<div>
						<!-- :on-change='uploadChange' -->
						<el-upload class="upload-demo" ref="upload" name="file" :multiple="false" :action="saction"
							:before-upload="uploadBefore" :on-success="uploadSuccess" :on-change="uploadChange"
							:headers="header" :show-file-list="false" :auto-upload="false">
							<label slot="trigger" class="ipeqtt">{{ $t("app_upload_template") }}</label>
							<el-button slot="trigger" style="margin-left: 10px" size="mini" type="primary">
								<i class="el-icon-upload2"></i>
								{{ $t("app_upload") }}
							</el-button>
							<label slot="trigger" style="margin-left: 10px">
								{{ cfile ? cfile.name : $t("app_unupload_file") }}
							</label>
							<div slot="tip" class="el-upload__tip" style="font-size: 14px">
								{{ $t("app_upload_completed_device") }}
							</div>
						</el-upload>
					</div>
					<div></div>
				</el-form-item>

				<el-form-item label="" :label-width="fwidth" v-if="config.type != 3 && config.type != 4">
					<div class="ipeqnum">3</div>
					<div class="ipeqspl1"></div>
					<label class="ipeqtt">{{ $t("app_choose_version") }}：</label>
					<el-radio v-for="item in $nwtypes" :key="item.vl" v-model="ever" :label="item.vl">{{item.lb}}
					</el-radio>
				</el-form-item>

				<el-form-item label="" :label-width="fwidth" v-if="config.type == 0 || config.type == 1">
					<div class="ipeqnum">4</div>
					<div class="ipeqspl2"></div>
					<label class="ipeqtt">{{ $t("app_choose_platform") }}：</label>
					<el-radio v-model="rqsType" label="0">{{ $t("terminal.default_platform") }}</el-radio>
					<el-radio v-model="rqsType" label="1">{{ $t("terminal.aliyun") }}</el-radio>
				</el-form-item>


				<el-form-item v-if='config.type == 0' label="" :label-width="fwidth">
					<div class="ipeqnum">5</div>
					<div class="ipeqspl2"></div>
					<label class="ipeqtt">{{ $t("terminal.device_model_2") }}：</label>
					<Model :config='mconfig'></Model> 
				</el-form-item>
				
				<el-form-item v-if='config.type == 0' label="" :label-width="fwidth">
					<div class="ipeqnum">6</div>
					<div class="ipeqspl2"></div>
					<label class="ipeqtt">{{ $t("terminal.device_model") }}：</label>
					<el-select v-model="model_2" :placeholder="$t('app_select')" style="width: 100%;">
						<el-option v-for="(item,index) in model_type_list" :key="index" :label="item.name"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item v-if='config.type == 0' label="" :label-width="fwidth">
					<div class="ipeqnum">7</div>
					<div class="ipeqspl1"></div>
					<label class="ipeqtt">{{ $t("app_choose_vendor") }}：</label>
					<Merchant :config="sortMc"></Merchant>
				</el-form-item>



				<el-form-item :label-width="fwidth">
					<el-button @click="showDia = false">{{ $t("app_cancel") }}</el-button>
					<el-button :disabled="!ready" type="primary" @click="submitUpload">{{ $t("app_imp") }}</el-button>
				</el-form-item>
			</el-form>
			<!-- <div slot="footer" class="dialog-footer">        
      </div> -->
		</el-dialog>
	</div>
</template>

<script>
	import Model from '@/components/Model.vue'
	import Merchant from "@/components/Merchant.vue";
	export default {
		data() {
			return {
				model_type_list: [{
						id: 0,
						name: "KS8303",
						value: "KS8303",
					},
					{
						id: 1,
						name: "ZTMD711",
						value: "ZTMD711",
					},
					{
						id: 2,
						name: "ZTMD715",
						value: "ZTMD715",
					},
					{
						id: 3,
						name: "KS8303 Plus",
						value: "KS8303 Plus",
					}
				
				],
				header: {},
				loading: false,
				fwidth: "60px",
				showDia: false,
				tform: {},
				rqsType: "0",
				ever: this.$evWifi,
				ready: false,
				cfile: "",
				mconfig: {},
				model_2: "",
				sortMc: {},
				dvtype: '',
				mcvl: ''
			};
		},
		components: {
			Model,
			Merchant
		},
		computed: {
			saction() {
				if (this.config.type == 0) {
					if (this.rqsType == 0) {
						return this.$eqExUlAction(this.ever, this.dvtype, this.mcvl,this.model_2);
					} else {
						return this.$aliEqExUlAction(this.ever, this.dvtype, this.mcvl,this.model_2);
					}
				} else if (this.config.type == 1) {
					if (this.rqsType == 0) {
						return this.$mcExUlAction(this.config.agid);
					} else {
						return this.$mcAliExUlAction(this.config.agid);
					}
				} else if (this.config.type == 3) {
					return this.$mcdteqExUlAction();
				} else {
					return this.$upgDtExUlAction(this.config.tid, this.ever);
				}
			},
		},
		props: ["ctotal", "config"],
		watch: {
			//// 0.equipement 1.agent 2.upgradedetail 3.merchant(商户)
			config(n) {
				this.showDia = n.showDia;
			},
		},
		mounted() {
			var _this = this

			this.header = {
				token: localStorage.token,
			};

			this.sortMc = {
				size: "",
				value: "",
				vlkey: 'clientKey',
				callback: vl => {
					_this.mcvl = vl ? vl : ""
				}
			}
			this.setModelCtrl('')
		},
		methods: {
			setModelCtrl(val) {
				var _this = this
				this.mconfig = {
					size: 'medium',
					isbatch: false,
					value: val,
					callback: vl => {
						_this.dvtype = vl
					}
				}
			},
			closeDia() {
				this.loading = false;
				this.ready = false;
				this.showDia = false;
				this.cfile = "";
				this.$refs.upload.clearFiles();
				this.rqsType = "0";
				this.ever = '0';
			},
			submitUpload() {
				this.loading = true;
				this.$refs.upload.submit();
				// this.$refs.upload.submit();   clearFiles
			},
			uploadChange(file, fileList) {
				// console.log(file, fileList)
				this.cfile = file;
				this.ready = file ? true : false;
			},
			uploadBefore(file) {
				console.log("before", file);
			},
			uploadSuccess(res, raw) {
				this.loading = false;
				this.closeDia();
				if (this.config.callback) this.config.callback();
				if (res.status == 200) {
					this.$message.success(res.message);
				} else {
					this.$message.error(res.message);
				}
			},
			downTempFile() {
				if (this.config.type == 0) {
					this.$getEqTempFile();
				} else if (this.config.type == 1) {
					this.$getMcTempFile();
				} else if (this.config.type == 3) {
					this.$getMcDtEqFile();
				} else {
					this.$getUpgDtTempFile();
				}
			},
		},
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.ipeqnum {
		width: 32px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		position: absolute;
		border: 1px solid rgba(0, 0, 0, 0.15);
		color: rgba(0, 0, 0, 0.25);
		font-weight: 400;
		left: -48px;
		border-radius: 32px;
	}

	.ipeqspl {
		height: 34px;
		width: 1px;
		left: -32px;
		top: 55px;
		position: absolute;
		background: rgba(0, 0, 0, 0.15);
	}

	.ipeqspl1 {
		height: 34px;
		width: 1px;
		left: -32px;
		top: -55px;
		position: absolute;
		background: rgba(0, 0, 0, 0.15);
	}

	.ipeqspl2 {
		height: 17px;
		width: 1px;
		left: -32px;
		top: -22px;
		position: absolute;
		background: rgba(0, 0, 0, 0.15);
	}

	.ipeqtt {
		font-size: 16px;
		color: rgba(0, 0, 0, 0.85);
	}
</style>
